<div *ngIf="!(data?.length > 0) && !loading" class="table-layout">
  {{ label | translate }}
</div>
